import React from 'react';
import type { HeaderGroup } from 'react-table';
import { SELECTION_COLUMN } from '../planner-table';

interface ITableHeaderProps<T extends Record<string, unknown>> {
	headerGroups: HeaderGroup<T>[];
	inGroup?: boolean;
}

const TableHeader = <T extends Record<string, unknown>>(props: ITableHeaderProps<T>) => {
	const { headerGroups, inGroup } = props;

	const getHeaderCell = (column: HeaderGroup<T>) => {
		if (column.id === SELECTION_COLUMN) {
			return inGroup ? '' : column.render('Header');
		} else {
			return <>{column.render('Header')}</>;
		}
	};

	return (
		<div className="table-header">
			{headerGroups.map(headerGroup => (
				<div {...headerGroup.getHeaderGroupProps()} className="table-row">
					{headerGroup.headers.map(column => (
						<div {...column.getHeaderProps()} className="table-header-cell">
							{getHeaderCell(column)}
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default TableHeader;
